import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import type { TaxonomyTheme } from '../../types/taxonomy';

import { DOMAIN_KVNL } from '../../config/constants';

import './style.scss';

interface ThemeHeaderProps {
  theme?: ImmutableEntity<TaxonomyTheme> | null;
  withTitle?: boolean;
}

const ThemeHeader: React.FC<ThemeHeaderProps> = ({ theme, withTitle = false }) => {
  const { t } = useTranslation();

  const currentDomain = config.get('CURRENT_DOMAIN');

  if (!theme || currentDomain === DOMAIN_KVNL) {
    return null;
  }

  const classes = classnames('Theme__wrapper', {
    'Theme__wrapper--hideTitle': !withTitle,
  });

  const data = theme.toJS();
  const mediaImage = data.field_media_image?.[0] as Record<string, any>;
  const title = data.name?.[0]?.value ?? '';
  const icon = mediaImage?.source ?? '';
  const alt = mediaImage?.entity?.field_media_svg?.[0]?.alt ?? '';
  const url = data.paths?.nl;

  // withTitle is used on the theme page itself, so no link needed
  const showAsLink = !withTitle && !!url;

  return (
    <div className={classes}>
      {showAsLink ? (
        <CoreLink href={url} className="Theme__wrapper__link">
          <div className="Theme__wrapper__icon" aria-hidden="true">
            <Image src={icon} alt="" />
          </div>
          <div className="Theme__wrapper__text">
            <span>{title}</span>
          </div>
        </CoreLink>
      ) : (
        <>
          <div className="Theme__wrapper__icon">
            <Image src={icon} alt={alt} />
          </div>
          <div className="Theme__wrapper__text">
            {withTitle ? (
              <>
                <div className="Theme__wrapper__theme">{t('tags.theme')}</div>
                <h1>{title}</h1>
              </>
            ) : (
              <span>{title}</span>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ThemeHeader;
